// Sistema de toast global — use em qualquer componente sem imports de context
// Uso: import { toast } from '../utils/toast';
//      toast.sucesso('Cliente salvo!')
//      toast.erro('Erro ao salvar.')
//      toast.aviso('Atenção: campo obrigatório.')
//      toast.info('Backup realizado.')

function disparar(mensagem, tipo = 'sucesso') {
  window.dispatchEvent(new CustomEvent('kzero-toast', { detail: { mensagem, tipo } }));
}

export const toast = {
  sucesso: (msg) => disparar(msg, 'sucesso'),
  erro:    (msg) => disparar(msg, 'erro'),
  aviso:   (msg) => disparar(msg, 'aviso'),
  info:    (msg) => disparar(msg, 'info'),
};
